import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useIsClient } from '@/hooks/useIsClient';
import { searchRequest } from '@/requests/searchRequest';
import SearchLoadMore from './SearchLoadMore';
import { SearchCard } from './SearchCard';
const SearchSection = ({ contentType, initialData, searchEndpoint, parentPage }) => {
    const [searchResults, setSearchResults] = useState(initialData);
    const [loadMoreStatus, setLoadMoreStatus] = useState('Pending');
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [pageSize] = useState(10);
    const isClient = useIsClient();
    const query = isClient ? new URLSearchParams(window.location.search).get('q') || '' : '';
    useEffect(() => {
        if (initialData?.items) {
            setLoadMoreStatus(initialData.items.length < pageSize ? 'Completed' : 'Pending');
        }
    }, [initialData, pageSize]);
    const fetchMoreResults = async () => {
        if (isLoadingMore || loadMoreStatus !== 'Pending')
            return;
        setIsLoadingMore(true);
        setLoadMoreStatus('Requesting');
        try {
            // Calculate the correct "from" parameter based on current items
            const currentItemsCount = searchResults?.items?.length || 0;
            const response = await searchRequest(searchEndpoint, {
                parentPage,
                contentType,
                q: query,
                from: currentItemsCount, // Start from where we left off
                pageSize,
                page: Math.floor(currentItemsCount / pageSize) + 1, // Calculate page number
            });
            if (response?.items) {
                setSearchResults((prev) => ({
                    ...response,
                    items: [...(prev?.items || []), ...response.items],
                }));
                setLoadMoreStatus(response.items.length < pageSize ? 'Completed' : 'Pending');
            }
        }
        catch (error) {
            console.error('Error loading more results:', error);
            setLoadMoreStatus('Pending'); // Allow retry
        }
        finally {
            setIsLoadingMore(false);
        }
    };
    const items = searchResults?.items || [];
    const renderCards = () => {
        if (items.length === 0)
            return null;
        return items.map((item, index) => (_jsx(SearchCard, { testid: `search-card-${index}`, item: item, contentType: contentType, index: index, parentComponentName: "Search" }, `search-card-${index}`)));
    };
    return (_jsxs(_Fragment, { children: [items.length > 0 && (_jsx("div", { className: "grid grid-cols-1 gap-1.5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4", children: renderCards() })), _jsx(SearchLoadMore, { status: loadMoreStatus, onLoadMore: fetchMoreResults })] }));
};
export default SearchSection;
